<template>
    <!-- eslint-disable -->
    <div>
        <v-card flat min-height="100%">
            <v-card-text class="pa-md-8">
                <v-subheader class="font-weight-bold pa-0 primary--text">Directorio de usuarios</v-subheader>
                <v-card flat outlined min-height="100%">
                    <v-toolbar flat>
                        <v-text-field
                            v-model="filter"
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo flat dense outlined
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn icon color="accent" @click="edit_user.open = true">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table
                        :headers="[{
                            text: 'Email',
                            value: 'email'
                        },{
                            text: '',
                            value: 'level',
                            align: 'center'
                        },{
                            text: '',
                            value: 'edit',
                            sorteable: false
                        }]"
                        :items="users"
                        locale="es-es"
                        :search="filter"
                    >
                        <template v-slot:item.level="{ item }">
                            <span v-if="item.level === LEVEL_ADMIN">Admin</span>
                            <v-chip color="yellow accent-4" small v-else-if="users_with_plants.findIndex( u => u.id === item.id ) === -1">
                                Sin plantas
                            </v-chip> 
                            </span>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="updateFormUser(item.id)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteForm(item.id)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <div class="py-16 text-center gray--text">
                                <v-icon large>mdi-account-circle-outline</v-icon>
                                <p>Clic en + para añadir usuarios<p/>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>
        </v-card>
        <formUser :open="edit_user.open" :user="edit_user.user" @close="updateFormUser"/>
        <formDelete :open="delete_user.open" :user="delete_user.user" @close="deleteForm()" />
    </div>
    <!-- eslint-enable -->
</template>

<script>
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission'
import { mapState, mapActions } from 'vuex'
import formUser from './users/form_user'
import formDelete from './users/delete_form'

export default {
    name: 'users',
    components: { formUser, formDelete },
    computed: {
        ...mapState({ users: state => state.account.list_users })
    },
    data() {
        return {
            LEVEL_ADMIN,
            open_new_user: false,
            edit_user: {
                open: false,
                user: null
            },
            delete_user: {
                open: false,
                user: null
            },
            filter: '',
            users_filtered: [],
            users_with_plants: []
        }
    },
    methods: {
        userAtLeastIs,
        ...mapActions({ getUserWithPlants: 'account/getUserWithPlants' }),
        updateFormUser(id){
            this.edit_user.user = id ? this.users.find( u => u.id == id): null
            this.edit_user.open = id ? true: false
            if(!id) this.updateUsersPlants()
        },
        deleteForm(id){
            this.delete_user.user = id ? id : null
            this.delete_user.open = id ? true : false
            if(!id) this.updateUsersPlants()
        },
        async updateUsersPlants(){
            try {
                this.users_with_plants = await this.getUserWithPlants()
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {
        this.updateUsersPlants()
    },
}
</script>